import { ConsultationFormData } from '../components/consultation/ConsultationForm';

const TELEGRAM_BOT_TOKEN = '7630134700:AAHN055LMlyjtxijk2aCxcpw_R9vmRREwek';
const TELEGRAM_CHAT_ID = '1423005071';

export async function sendTelegramNotification(data: ConsultationFormData) {
  const message = `
🎯 New Consultation Request

👤 Name: ${data.name}
📧 Email: ${data.email}
🏢 Company: ${data.company || 'N/A'}
📱 Phone: ${data.phone || 'N/A'}
📅 Date: ${data.preferredDate}
⏰ Time: ${data.preferredTime}
🌍 Timezone: ${data.timezone}
🎨 Selected Solution: ${data.selectedSolution || 'Not specified'}

💬 Message:
${data.message}
`;

  try {
    const response = await fetch(`https://api.telegram.org/bot${TELEGRAM_BOT_TOKEN}/sendMessage`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        chat_id: TELEGRAM_CHAT_ID,
        text: message,
        parse_mode: 'HTML'
      })
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(`Telegram API error: ${data.description}`);
    }
  } catch (error) {
    console.error('Telegram notification error:', error);
  }
}